var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrelimAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12549",
    "data-name": "Group 12549",
    transform: "translate(-168 -288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    transform: "translate(168 288)",
    fill: "none",
    stroke: "#74613c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "6 9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 7.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(172.25 292.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M17.875,24.75a.954.954,0,0,1-1-.9V7.65a1.006,1.006,0,0,1,2,0v16.2A.954.954,0,0,1,17.875,24.75Z",
    transform: "translate(-2.125)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M23.85,18.875H7.65a1.006,1.006,0,0,1,0-2h16.2a1.006,1.006,0,0,1,0,2Z",
    transform: "translate(0 -2.125)",
    fill: "#74613c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrelimAdd);
export default __webpack_public_path__ + "static/media/prelimAdd.3b3ca655f67b54245b93ef2ca513f63e.svg";
export { ForwardRef as ReactComponent };